import { omit } from 'lodash'

const TRANSIENT_MEDIA_KEYS = ['file', 'imageUrl', 'needUpload', 'uploadProgress']

/**
 * Strip runtime-only fields before persisting media to Firestore.
 */
export function toPersistableMediaObject(media) {
  if (!media || typeof media !== 'object') return null
  const cleaned = omit(media, TRANSIENT_MEDIA_KEYS)
  if (!cleaned.fileName || !cleaned.fileExt) return null
  return {
    fileName: cleaned.fileName,
    fileType: cleaned.fileType || null,
    fileExt: cleaned.fileExt,
    isAvatar: !!cleaned.isAvatar,
    isLayout: !!cleaned.isLayout,
    storagePath: cleaned.storagePath || null,
    publicUrl: cleaned.publicUrl || null,
  }
}

/**
 * @param {string} docId
 * @param {{ fileName?: string, fileExt?: string, storagePath?: string }} media
 * @param {string} [defaultStoragePath] fallback logical root when media.storagePath is missing
 */
export function seoOgStorageChildPath(docId, media, defaultStoragePath = null) {
  if (!media?.fileName || !media?.fileExt || !docId) return null
  const root = media.storagePath || defaultStoragePath
  if (!root) return null
  return `${root}/${docId}/${media.fileName}.${media.fileExt}`
}
